module.exports = __webpack_public_path__ + "static/media/wznhjcRegister2.5ee59bfa.docx";